import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Control, Errors } from 'react-redux-form';
import { RightArrow } from '@forwardfinancing/component-library';


class RadioButtonFormField extends Component {
  renderRadioButton() {
    const {
      displayName,
      attributeName,
      modelName,
      optionsData,
      isRequired,
      desiredClassName,
      onChangeOfValue,
      isTouched
    } = this.props;

    let group = (
      <div key={attributeName} className={`${desiredClassName}__field-group field`}>
        <label className={`${desiredClassName}__field-label`}>
          {displayName}
        </label>
        <span className={`${desiredClassName}__field-control control is-small`}>
          {optionsData.map((opt, i) => {
            return (
              <label key={i} className={`${desiredClassName}__field-control-radio radio`}>
                <Control.radio
                  model={`${modelName}.${attributeName}`}
                  value={opt}
                  onChange={onChangeOfValue || null}
                />
                {opt}
              </label>
            );
          })}
        </span>
      </div>
    );
    if (isRequired) {
      group = (
        <div key={attributeName} className={`${desiredClassName}__field-group field`}>
          <label className={`${desiredClassName}__field-label required`}>
            {`${displayName} *`}
          </label>
          <span className={`${desiredClassName}__field-control control is-small`}>
            <Errors
              className="help is-danger"
              model={`${modelName}.${attributeName}`}
              show={isTouched}
              messages={{
                required: 'Please make a selection'
              }}
              component={(props) => <span><RightArrow /> {props.children}</span>}
            />
            <span className={`${desiredClassName}__field-control-radio radio`}>
              {optionsData.map((opt, i) => {
                return (
                  <label key={i} className={`${desiredClassName}__field-inner radio`}>
                    <Control.radio
                      model={`${modelName}.${attributeName}`}
                      value={opt}
                      onChange={onChangeOfValue || null}
                      validators={{
                         required: (val) => val && val.length
                      }}
                    />
                    {opt}
                  </label>
                );
              })}
            </span>
          </span>
        </div>
      );
    }
    return group;
  }

  render() {
    return (
      <div className="radio-button-form-field">
        {this.renderRadioButton()}
      </div>
    );
  }
}

// NOTE: this is intended to work with a react-redux-form <Form />
RadioButtonFormField.propTypes = {
  displayName: PropTypes.string.isRequired,
  attributeName: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  optionsData: PropTypes.array.isRequired,
  isRequired: PropTypes.bool.isRequired,
  desiredClassName: PropTypes.string.isRequired,
  onChangeOfValue: PropTypes.func,
    isTouched: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

RadioButtonFormField.defaultProps = {
  isTouched: 'touched'
};

export default RadioButtonFormField;
